<template>
    <div v-if="loaded">
        <div v-if="exist" class="container-fluid">
            <vue-headful
                    :title="content.title"
                    :description="content.description"
                    :keywords="content.keywords"
                    :url="pageUrl"
            />
            <navigation-bar />

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" :data-bg="content.image">
                <div class="container">
                    <p class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;">{{ content.name }}</p>
                </div>
            </div>

            <div class="container-fluid mt-subpage-section m-0 p-0">
                <div class="container-fluid m-0 p-0">
                    <div class="lazy container-fluid">

                        <div class="container">
                            <div class="content-container p-3 pt-5" v-html="content.content">
                            </div>

                            <main-footer/>

                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div v-else id="404-page">
            <page-not-found/>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {Const} from "@/main";
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import PageNotFound from "@/components/commons/PageNotFound";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "DefaultPage",
        components: {PageNotFound, MainFooter, NavigationBar},
        data () {
            return {
                locale: this.$i18n.locale,
                content: {},
                exist: false,
                loaded: false,
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted () {
            axios.get(`${Const.API_HOST}/${this.locale}/content/page`, {
                params: {
                    "url": this.$route.path
                }
            })
            .then(function (response) {
                return {
                    status: response.status,
                    body: response.data
                };
            }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(resp => {
                this.exist = (resp.status === 200)
                if (!this.exist) {
                    const metaRobots = document.createElement('meta');
                    metaRobots.name = 'robots';
                    metaRobots.content = 'noindex';
                    document.head.appendChild(metaRobots);
                }
                this.content = resp.body
                this.loaded = true

                this.$nextTick(() => {
                    lazyLoadInstance.update()

                    const el = document.querySelector(this.$route.hash)
                    if (el) {
                      var rect = el.getBoundingClientRect();
                      var win = el.ownerDocument.defaultView;

                      window.scrollTo({
                        top: rect.top + win.pageYOffset,
                        left: 0,
                        behavior: 'smooth'
                      });
                    }
                })
            });
        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }
</style>